/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { ZumperTheme } from '../types'

export const Z4: ZumperTheme = {
  name: 'Bolt',
  colors: {
    accent: '#04425D',
    accentLight: '#50788B',
    background: '#EBEAE6',
    backgroundDark: '#EBEAE6',
    backgroundMedium: '#F1F1ED',
    backgroundLight: '#F9F9F6',
    backgroundLightest: '#FFFFFF',
    errorColor: '#E32E12',
    neutralLight: '#C9DADE',
    primary: '#E5105A',
    primaryButton: '#022C3B',
    primaryButtonDark: '#022C3B',
    primaryDark: '#8F0A3F',
    primaryHover: '#DB0F5A',
    primaryInactive: '#022C3B',
    secondary: '#022C3B',
    secondaryDark: '#022531',
    secondaryHover: '#04425D',
    secondaryInactive: '#EBEAE6',
    text: '#0A0F1C',
    textLight: '#454442',
    textLightest: '#726F6C',
  },
  typography: {
    bodyFontFamily: 'Moderat, "Moderat Fallback"',
    displayFontFamily: 'Figtree, "Figtree Fallback"',
    fontSize48: '48px',
    fontSize40: '40px',
    fontSize32: '32px',
    fontSize28: '28px',
    fontSize24: '24px',
    fontSize20: '20px',
    fontSize16: '16px',
    fontSize14: '14px',
    fontSize12: '12px',
    fontSize11: '11px',
    fontWeightBold: 700,
    fontWeightRegular: 600,
    fontWeightMedium: 500,
    fontWeightLight: 400,
  },
  spacing: {
    spacing1: '2px',
    spacing2: '4px',
    spacing3: '8px',
    spacing4: '16px',
    spacing5: '24px',
    spacing6: '32px',
    spacing7: '40px',
    spacing8: '48px',
    spacing9: '56px',
    spacing10: '64px',
  },
}

export const Z4Figtree: ZumperTheme = {
  ...Z4,
  typography: {
    ...Z4.typography,
    displayFontFamily: `Figtree, ${Z4.typography.displayFontFamily}`,
  },
}
